// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bek_a bhk_bj"};